import React, { useEffect, useState, ReactNode } from "react";
import { useLocation } from "react-router-dom";

import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import "./layout.scss";
import logger from "../utils/logger";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const [hideFooter, setHideFooter] = useState<boolean>(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    logger.debug("Current pathname", { pathname });
    if (pathname.includes("marketplace")) {
      setHideFooter(true);
    } else {
      setHideFooter(false);
    }
  }, [pathname]);

  return (
    <>
      <>
        <Header />
        <main className="overflow-hidden bg-color-dark">{children}</main>
        {hideFooter ? null : <Footer />}
      </>
    </>
  );
};

export default Layout; 